import { apiRequest } from "api";
import { BASE_URL } from "constants/routes";
import { createAsyncThunk } from '@reduxjs/toolkit'
import { SUCCESS_RESPONSE_LIST } from "constants/api";
import { ClearUploadedDocument, deleteUploadedDocument, setDeleteSameFile, setDocuments, setFetchedDocument, setResponseObject, setUploadedDocument ,setFaceObject, setVerificationResponse} from "redux/uploadDocumentReducer";
import { setVkycResponse } from "redux/vkycReducer";
import { setApplicantUser, setPrimaryUser, setUserDetail } from "redux/userInfo";
import { clearSelectedDataKey, setSelectedData,fetchSelectedFormData } from "redux/formDisplay";
import { encryptPayload } from "./encrypt";
import { encryptUrl } from "./UrlEncryption";
import { useDispatch } from "react-redux";
import { getFieldsToSet, getIndianTime } from "helper/common";
var CryptoJS = require("crypto-js")

export const createPrimaryWorkFlow = async (data, cb) => {
  const req = `${BASE_URL}/workflow/createPrimaryWorkFlow`;
  let params = {
    body: data
  }
  const encryptedBodyRes = await encryptPayload('', params, true, true);
  const options = {
    method: 'POST',
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(encryptedBodyRes)
  }
  const _options = {
    method: 'POST',
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data)
  }

  try {
    const result = await encryptPayload(req, options, false, true,true);
    // const result = await encryptPayload(req, _options, false, false);
    const { status, data } = result
    if (SUCCESS_RESPONSE_LIST.includes(status)) {
      if(cb) {
        //* Encryption url currently here
        const slicedUrl = data.link.split("/").slice(-2)
        let idToEncrypt = ""
        slicedUrl.forEach((item)=>{
          idToEncrypt+=item + "/"
        })
        idToEncrypt = idToEncrypt.substring(0,idToEncrypt.length-1);
        // dispatch(encryptUrl(data.link))
        //Callback to conditional redirection url with primaryWfId and subWfId
        cb(data.link)
      }
      return data
    }
  }
  catch (error) {
    throw error
  }
}

export const createSubWorkFlow = async (data, cb) => {
  const req = `${BASE_URL}/workflow/createSubWorkflow`;
                                    
  let params = {
    body: data
  }
  const encryptedBodyRes = await encryptPayload('', params, true, true);
  const options = {
    method: 'POST',
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(encryptedBodyRes)
  }
  const _options = {
    method: 'POST',
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data)
  }

  try {
    const result = await encryptPayload(req, options, false, true,true);
    // const result = await encryptPayload(req, _options, false, false);
    const { status, data } = result
    if (SUCCESS_RESPONSE_LIST.includes(status)) {
      if(cb) {
        //* Encryption url currently here
        const slicedUrl = data?.link?.split("/").slice(-2)
        let idToEncrypt = ""
        slicedUrl?.forEach((item)=>{
          idToEncrypt+=item + "/"
        })
        idToEncrypt = idToEncrypt.substring(0,idToEncrypt.length-1);
        // dispatch(encryptUrl(data.link))
        //Callback to conditional redirection url with primaryWfId and subWfId
        cb(data.link)
      }
      return data
    }
  }
  catch (error) {
    throw error
  }
}


// export const saveWorkflowInfo = (data, userId) => {
//   const req = `${BASE_URL}/workflow/saveWorkflowInfo`;
//   const options = {
//     method: 'POST',
//     headers: {
//       "Content-Type": "application/json",
//     },
//     body: JSON.stringify({
//       id: userId,
//       ...data
//     })
//   }
//   try {
//     const result = apiRequest(req, options);
//   }
//   catch (error) {
//     throw error
//   }
// }

export const getWorkflowData = async (id) => {

  const req = `${BASE_URL}/workflow/getWorkflowInfoById`
  let params = {
    body: {_id: id}
  }
  const encryptedBodyRes = await encryptPayload("",params,true,true)
  const options = {
    method: 'POST',
    body: JSON.stringify(encryptedBodyRes),
    headers: {
      "Content-Type": "application/json"
    },
  }
  const _options = {
    method: 'POST',
    body: JSON.stringify({_id: id}),
    headers: {
      "Content-Type": "application/json"
    },
  }
  try {
    const result = await encryptPayload(req, options, false, true,true);
    // const result = await encryptPayload(req, _options, false, false);
    // console.log({result});
    return result.data
  }
  catch (err) {
    // console.log(err)
  }
}

export const fetchWorkflow = createAsyncThunk("fetchApi/workflowInfo", async (id, { dispatch }) => {
  
  const req = `${BASE_URL}/workflow/getWorkflowInfoById`
  let params = {
    body: {_id: id}
  }
  const encryptedBodyRes = await encryptPayload("",params,true,true)
  const options = {
    method: 'POST',
    body: JSON.stringify(encryptedBodyRes),
    headers: {
      "Content-Type": "application/json"
    },
  }
  const _options = {
    method: 'POST',
    body: JSON.stringify({_id: id}),
    headers: {
      "Content-Type": "application/json"
    },
  }
  try {
    const result = await encryptPayload(req,options,false,true,true)
    // const result = await encryptPayload(req, _options, false, false);
    dispatch(setFetchedDocument(result?.data?.documents))
    delete result.data._id;
    return result.data
  }
  catch (err) {
    // console.log(err)
  }
})

export const getWorkflowInfo = createAsyncThunk("userInfo/getWorkflowInfo", async (id,{dispatch}) => {

  const req = `${BASE_URL}/workflow/getWorkflowInfoById`
  let params = {
    body: {_id: id}
  }
  const encryptedBodyRes = await encryptPayload("",params,true,true)
  const options = {
    method: 'POST',
    body: JSON.stringify(encryptedBodyRes),
    headers: {
      "Content-Type": "application/json"
    },
  }
 
  const _options = {
    method: 'POST',
    body: JSON.stringify({_id: id}),
    headers: {
      "Content-Type": "application/json"
    },
  }
  try {
    const result = await encryptPayload(req,options,false,true,true)
    // const result = await encryptPayload(req, _options, false, false);
    delete result.data._id;
    if(SUCCESS_RESPONSE_LIST.includes(result?.status)){
      // dispatch(setFetchedDocument(result?.data?.documents))
    }
    return result.data
  }
  catch (err) {
    // console.log(err)
  }
})


// export const getWorkflowDataInfo = async (id) => {
//   const req = `${BASE_URL}/workflow/getWorkflowInfoById`;
//   let params = {
//     body: {_id: id},
//   };
//   const encryptedBodyRes = await encryptPayload("", params, true, true);
//   const options = {
//     method: "POST",
//     headers: {
//       "Content-Type": "application/json",
//     },
//     body: JSON.stringify(encryptedBodyRes),
//   };
//   try {
//     const result = await encryptPayload(req,options,false,true,true)
//     if(result?.data?.digilocker_callback_response)
   
//     if(SUCCESS_RESPONSE_LIST.includes(result?.status)){
//     }
//     return result.data
//   }
//    catch (err) {
//     console.log(err);
//     return "";
//   }
// };

export const updateWorkflowInfo = createAsyncThunk("userInfo/updateWorkflowInfo", async (data, { dispatch }) => {
  const req = `${BASE_URL}/workflow/updateWorkflowInfo`;
  let params = {
    body: {...data, last_modified_at: getIndianTime()}
  }
  const encryptedBodyRes = await encryptPayload('', params, true, true);
  const options = {
    method: 'POST',
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify(encryptedBodyRes)
  }
 
  try {
    const result = await encryptPayload(req, options, false, true,true);
    // const result = await encryptPayload(req, _options, false, false);

    const { status } = result
    // console.log(result)
    if (SUCCESS_RESPONSE_LIST.includes(status)) {
      // dispatch(getWorkflowInfo(data.userId))
      // dispatch(fetchWorkflow(data.userId))
      dispatch(setApplicantUser({ ...result.data.source_data, _id: result.data._id }))
      let formattedData = result.data;
      const { uploadedDocument } = formattedData;

      const { source_data } = result.data;
      if (source_data) {
        delete formattedData.source_data;
      }

      if (uploadedDocument) {
        delete formattedData.uploadedDocument;
      }
      dispatch(fetchSelectedFormData({...formattedData, ...source_data}))
      dispatch(ClearUploadedDocument())
      // let flatSelectedData = flatten(action.payload)
      // state.selectedData = { ...flatSelectedData }

    }
  } catch (err) {
    throw err
  }
})

export const updatePrimaryWorkflow = createAsyncThunk("userInfo/updatePrimaryWorkflow", async (data, { dispatch }) => {
  const req = `${BASE_URL}/workflow/updatePrimaryWorkflow`;
  let params = {
    // * Adding a timestamp to capture the changes made via this API
    body: {...data, last_modified_at : getIndianTime()}
  }
  const encryptedBodyRes = await encryptPayload('', params, true, true);
  const options = {
    method: 'POST',
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify(encryptedBodyRes)
  }
  const _options = {
    method: 'POST',
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify({...data})
  }

  try {
    const result = await encryptPayload(req, options, false, true,true);
    // const result = await encryptPayload(req, _options, false, false);

    // const { status } = result
    // if (SUCCESS_RESPONSE_LIST.includes(status)) {
    //   dispatch(getWorkflowInfo(data.userId))
    //   // dispatch(fetchWorkflow(data.userId))
    // }
  } catch (err) {
    throw err
  }
})

export const getGeolocations = createAsyncThunk(
  "fetchApi/fecthReverseLocation",
  async (params) => {
    const req = `${BASE_URL}/workflow/fecthReverseLocation`;
    let req_body = {
      body: params,
    };
    const encryptedBodyRes = await encryptPayload("", req_body, true, true);
    const options = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(encryptedBodyRes),
    };
    try {
      const result = await encryptPayload(req, options, false, true,true);
      return result;
    } catch (err) {
      // // console.log(err);
    }
  }
);


export const uploadUserDocument = createAsyncThunk("userInfo/uploadDocument", async (data, { dispatch }) => {
  const req = `${BASE_URL}/workflow/uploadWorkflowFile`;
  const {
    setSelectedData,
    formErr,
    setFormErr,
    clearFieldError,
    docType,
    service_type,
    masking_required,
    selectedData,
    isRecursive,
    doc_number_validation,
    dob,
    face_match_doc_id,
    face_match_required,
    face_match_document,
    compare_doc,
    face_match_acceptance_threshold,
    mrz_validity,
    conversion_required,
    conversion_filename,

  } = data;
  let formData = new FormData();
  let userId = data?.userInfo?.userId;
  let primaryWorflowId = data?.userInfo?.primaryWorkflowId;
  const subworkflow_id = data?.userInfo?.subWfId;
  let userdata = {
    user_id: userId,
    primary_workflow_id: primaryWorflowId,
    organisation_id: data.userInfo.organisationId,
    field_name: data.name,
    field_label: data.label,
    verify: data?.verify,
    extraction_required: data?.extraction_required,
    subworkflow_id: subworkflow_id,
    doc_type: docType,
    service_type: service_type,
    masking_required: masking_required,
    recursiveSection:isRecursive,
    doc_number_validation : doc_number_validation,
    dob : dob,
    faceMatch:face_match_required,
    faceMatchDocumentId:face_match_doc_id,
    faceMatchDocument:face_match_document,
    compareDoc:compare_doc,
    faceMatchThreshold:face_match_acceptance_threshold,
    mrz_validity : mrz_validity,
    conversion_required:eval(conversion_required),
    conversion_filename:conversion_filename,
  };
  formData.append("file", data.acceptedFile[0].file);
  let params = {
    body: userdata,
  };
  const encryptedBodyRes = await encryptPayload("", params, true, true);
  formData.append("data", JSON.stringify(encryptedBodyRes));

  let form = new FormData();
  form.append("data", JSON.stringify(encryptedBodyRes));
  form.append("file", data.acceptedFile[0].file);
  const options = {
    method: "POST",
    body: form,
  };
  try {
    data?.autofill?.forEach((item) => {
      dispatch(
        setSelectedData({ key: [`${item?.destination_field}`], value: null })
      );
    });
    let response = await encryptPayload(req, options, false, true);
    if (SUCCESS_RESPONSE_LIST.includes(response.status)) {
      let responseData = { ...response?.data };
      if (responseData?.verification_response) {
        delete responseData.verification_response;
      }
      if(face_match_document){
        if(response.data?.verification_response?.error_code != "dv-001" ){
          let doc_type= response.data?.verification_response?.document_type.toLowerCase();
          if( doc_type === "driving_licence" || doc_type ===  "pan_card"|| doc_type === "passport" || doc_type === "aadhaar_card"){
            let faceResponseData=response.data
            delete responseData?.docContent
            delete responseData?.compareDocument_type
            dispatch(setResponseObject({ key: data.name, value:responseData  }));
            dispatch(setFaceObject({ key: data.name, value:faceResponseData })); 
            dispatch(setSelectedData({ key: data.name, value: responseData  }));
            dispatch(setDocuments({ key: data.name, value: responseData }));
            return response
          }
          else{
            return
          }       
        }else{
          return response
        }
      }
      if(face_match_required){
        if(response.data?.FaceMatchresponse?.status == "success"){
          let faceResponseData=response.data
          delete responseData.FaceMatchresponse
          dispatch(setSelectedData({ key: data.name, value: faceResponseData }));
          dispatch(setResponseObject({ key: data.name, value: responseData }));
          dispatch(setDocuments({ key: data.name, value: responseData }));
          dispatch(
            setVerificationResponse({
              key: data.name,
              value: faceResponseData?.FaceMatchresponse,
            })
          );
          return response.data?.FaceMatchresponse
        }else{
          dispatch(deleteUploadedDocument({ key: data.name }));
          return response.data?.FaceMatchresponse
        }
      }
      if(isRecursive){
        dispatch(setResponseObject({ key: responseData?.encrypted_filename, value: responseData }))
      }
      else{
        dispatch(setResponseObject({ key: data.name, value: responseData }));
        dispatch(setDocuments({ key: data.name, value: responseData }));
      }
      dispatch(setSelectedData({ key: data.name, value: responseData }));
      if (response.data?.verification_response) {
        const { verification_response } = response.data;
        if(isRecursive){
          let verificationRespons = {...selectedData?.verification_response,[data.name] : verification_response}
          dispatch(setSelectedData({ key: 'verification_response', value: verificationRespons }));
        }else{
          dispatch(
            setVerificationResponse({
              key: data.name,
              value: response.data.verification_response,
            })
          );
        }
        const all_source_fields = getFieldsToSet(
          data.autofill,
          verification_response
        );
        if (formErr[data.name]) {
          delete formErr[data.name];
        }
        all_source_fields.forEach((item) => {
          dispatch(setSelectedData({ key: item.key, value: item.value }));
          if (formErr[item.key]) {
            delete formErr[item.key];
            clearFieldError && clearFieldError(item.key);
          }
        });
        setFormErr && setFormErr(formErr);
      }
      return response;
    } else {
      dispatch(
        setVerificationResponse({
          key: data?.name,
          value: response?.data?.verification_response,
        })
      );
      dispatch(deleteUploadedDocument({ key: data.name }));
      dispatch(setSelectedData({ key: data.name, value: null }));
      return response;
    }
  } catch (err) {
    // console.log(err);
  }
})

export const verifyDocumentNumber = async (data) => {
  const req = `${BASE_URL}/workflow/documentNumberExtraction`;
  let userdata = {
    document_number: data?.data,
    verify: data?.verify,
    dob : data?.dob,
    doc_type: data?.docType,
    organisation_id : data?.selectedData?.organisation_id,
    verification_id:data?.verification_id,
    subworkflow_id: data?.subworkflows?._id,
    state:data?.state,
    substring_exprn:data?.substring_exprn


  };

  let params = {
    body: userdata,
  };

  const encryptedBodyRes = await encryptPayload("", params, true, true);
  const options = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(encryptedBodyRes),
  };
  try {
    let response = await encryptPayload(req, options, false, false);
      return response;
   
  } catch (err) {
    console.log(err);
    return "";
  }
};
export const generatePinCodeDeatils = async (data) => {
  const req = `${BASE_URL}/workflow/getPinCodeRegion`;
  let userdata = {
    pin_code: data?.data,
    verify: data?.verify,
    fieldName:data?.id,
    doc_type: data?.docType,
    organisation_id : data?.selectedData?.organisation_id,
    verification_id:data?.verification_id,
    workflow_id: data?.subworkflows?._id,
  };
  let params = {
    body: userdata,
  };

  const encryptedBodyRes = await encryptPayload("", params, true, true);
  const options = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(encryptedBodyRes),
  };
  try {
    let response = await encryptPayload(req, options, false, true);
      return response;
   
  } catch (err) {
    console.log(err);
    return "";
  }
};

export const fetchAddressDataFromPincode = async (data) => {
  const req = `${BASE_URL}/workflow/getAddressDetailsFromPincode`;
 
  let params = {
    body: data,
  };

  const encryptedBodyRes = await encryptPayload("", params, true, true);
  const options = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(encryptedBodyRes),
  };
  try {
    let response = await encryptPayload(req, options, false, true);

    return response;
  } catch (err) {
    console.log(err);
    return "";
  }
};

export const uploadMultipleDocument = createAsyncThunk("userInfo/uploadDocument", async (data, { dispatch }) => {
  const req = `${BASE_URL}/workflow/uploadWorkflowFile`;
  const {setSelectedData} = data
  let formData = new FormData();
  let userId = data?.userInfo?.userId
  let primaryWorflowId = data?.userInfo?.primaryWorkflowId;
  const subworkflow_id = data?.userInfo?.subWfId;
  let userdata = {
    "user_id":userId,
    "primary_workflow_id":primaryWorflowId,
    "field_name":data.name,
    "field_label":data.label,
    "organisation_id" : data.userInfo.organisationId,
    "subworkflow_id" :subworkflow_id
  }
  formData.append("file", data.acceptedFile.file);
  let params = {
    body: userdata
  }
  const encryptedBodyRes = await encryptPayload('', params, true, true);
  formData.append("data", JSON.stringify(encryptedBodyRes));
  
  
  let form = new FormData();
  form.append("data",JSON.stringify(encryptedBodyRes))
  form.append("file",data.acceptedFile.file);
  const options = {
    method: 'POST',
    body: form
  }
  try {
    let response = await encryptPayload(req, options, false, true);
    if (SUCCESS_RESPONSE_LIST.includes(response.status)) {
      dispatch(setSelectedData({ key: data.name, value: response.data }))
      dispatch(setDocuments({ key: data.name, value: response.data }))
      dispatch(setResponseObject({ key: data.name, value: response.data }))
    }
  } catch (err) {
    throw err
  }
})

export const removeUserDocument = createAsyncThunk("userInfo/removeDocument", async (data, { dispatch }) => {

    const req = `${BASE_URL}/workflow/deleteDocument`;
    const {setSelectedData} = data

  const options = {
    method: 'POST',
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify(data)
  }

  try {
    const result = await apiRequest(req, options);
    // if (SUCCESS_RESPONSE_LIST.includes(result.status)) {
    //   dispatch(setResponseObject({ key: data.name, value: result.data }))
    // }
    
    if(result?.status === "success") {
      if(data?.type === "multipleFileUpload"){
        dispatch(setDeleteSameFile({key: data.objName, value: data?.uploadedDocument[`${data.name}`].original_filename}))
      }
      dispatch(deleteUploadedDocument({ key: data.name, value: null }))
      dispatch(clearSelectedDataKey({ key: data.name }))
      dispatch(setSelectedData({key: data.name, value: null}))
      if (data?.fileData[`${data.objName}`].length - 1 == 0){
        dispatch(setSelectedData({key: data.objName, value: null}))
      }   
    }
  } catch (err) {
    throw err
  }
})

export const getCountriesCode = createAsyncThunk( 
  "staticData/getCountriesCode",
  async () => {
  const req = `${BASE_URL}/workflow/getCountriesList/`
  const encryptedAPIParams = await encryptPayload("","",true,false)
  const options = {
    method: 'POST',
    body: JSON.stringify(encryptedAPIParams),
    headers: {
      "Content-Type": "application/json"
    },
  }
  const _options = {
    method: 'POST',
    headers: {
      "Content-Type": "application/json"
    },
  }

  try {
    const result = await encryptPayload(req,options,false,true,true)
    // const result = await encryptPayload(req, _options, false, false);
    return result.data
  }
  catch (err) {
    // console.log(err)
  }
});

export const initiateVKyc = createAsyncThunk("userInfo/initiateVKyc", async (data, { dispatch }) => {
  const req = `${BASE_URL}/workflow/initiateVKyc`
  
  const options = {
    method: 'POST',
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify(data)
  }
  try {
    const result = await apiRequest(req, options)
    dispatch(setVkycResponse(result.data))
    return result.data
  }
  catch (err) {
    // console.log(err)
  }
})


export const deleteWorkflowInfoById = createAsyncThunk("fetchApi/deleteWorkflowInfoById", async (id) => {
  const req = `${BASE_URL}/workflow/deleteWorkflowInfoById/${id}`;

  const options = {
    method: 'POST',
    headers: {
      "Content-Type": "application/json"
    },
    // body: JSON.stringify(body)
  } 
  try {
    const result = await apiRequest(req,options);
    return result.data;
  } catch (err) {
    console.error(err)
  }
})

export const updateApplicantStatusAndSubWorkflowStatus = createAsyncThunk("userInfo/updateApplicantStatusAndSubWorkflowStatus", async (data, { dispatch }) => {
  const req = `${BASE_URL}/workflow/updateStatusOfApplicantAndSubWorkflow`;
  let  body= { status:data.status, applicant_id:data.applicant_id}
  if(data?.active_step) {
    body.active_step = data.active_step
  }
  
  // const encryptedBodyRes = await encryptPayload('', params, true, true);

  const options = {
    method: 'POST',
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify(body)
  }

  try {
    const result = await apiRequest(req, options)
    return result.data

  } catch (err) {
    throw err
  }
})

export const getAuditDocument = async (data) => {

  const req = `${BASE_URL}/workflow/getAuditDocument`
  let params = {
    body: data
  }
  const encryptedBodyRes = await encryptPayload("",params,true,true)
  const options =  {
    method : 'POST',
    body : JSON.stringify(encryptedBodyRes),
    headers : {
      "Content-Type": "application/json"
    },
  }
  const _options = {
    method: 'POST',
    body: JSON.stringify(data),
    headers: {
      "Content-Type": "application/json"
    },
  }
  try {
    // const result = await encryptPayload(req, options, false, true);
    const result = await encryptPayload(req, _options, false, false,true);
    // console.log({result});
    return result
  }
  catch (err) {
    // console.log(err)
  }
}

export const updateLastLoginInfo = async (data) => {
  const req = `${BASE_URL}/workflow/updateLastLoginInfo`;
  let params = {
    body: {...data}
  }
  const encryptedBodyRes = await encryptPayload('', params, true, true);
  const options = {
    method: 'POST',
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify(encryptedBodyRes)
  }

  try {
    const result = await encryptPayload(req, options, false, true,true);
    const { status } = result
    return result

  } catch (err) {
    console.log(err)
  }
}


export const digilocker = async (data, cb) => {
  const req = `${BASE_URL}/workflow/digilocker`;
  let info = {
      organisation_id: data?.organisation_id,
      sub_id : data?.sub_id,
      primary_workflow_id : data?.primary_workflow_id
  }                       
  let params = {
    body: info
  }
  
 const encryptedBodyRes = await encryptPayload("", params, true, true);
  const options = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(encryptedBodyRes),
  };
  try {
    let response = await encryptPayload(req, options, false, false);
      return response?.link?.result || response;
   
  } catch (err) {
    console.log(err);
    return "";
  }
}


export const livenessDetection = async (data, cb) => {
  const req = `${BASE_URL}/workflow/livenessDetection`;
  let formData = new FormData();
  
  let userdata = {
    sub_id : data?.sub_id,
    organisation_id: data?.organisationId,    
    user_action : data?.userAction,
    name : data?.name,
    direction : data?.direction,
    primary_workflow_id : data?.primary_workflow_id
  };
  formData.append("file", data.acceptedFile[0].file);
  let params = {
    body: userdata,
  };
  const encryptedBodyRes = await encryptPayload("", params, true, true);
  formData.append("data", JSON.stringify(encryptedBodyRes));
  const options = {
    method: "POST",
    body: formData,
  };



  try {
    let response = await encryptPayload(req, options, false, false);
      return response;
   
  } catch (err) {
    console.log(err);
    return "";
  }
}

export const checkPlaceSuggestion =  async (data,suggestion_type) => {
  const req = `${BASE_URL}/workflow/autoCompletetSuggestion`
  
  let inputData = {
    input:data,
    type:suggestion_type
  };
  let params = {
    body: inputData,
  };
  const encryptedBodyRes = await encryptPayload("", params, true, true);
  const options = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(encryptedBodyRes),
  };
  try {
    let response = await encryptPayload(req, options, false, false);
      return response;
   
  } catch (err) {
    console.log(err);
    return "";
  }
}

export const getBankList = createAsyncThunk( 
  "staticData/getBankList",
  async (payload) => {
  let params = {
    body: payload
  };
  const req = `${BASE_URL}/workflow/getLiveBankList`
  const encryptedAPIParams = await encryptPayload("",params,true,true)
  const options = {
    method: 'POST',
    body: JSON.stringify(encryptedAPIParams),
    headers: {
      "Content-Type": "application/json"
    },
  }
  const _options = {
    method: 'POST',
    headers: {
      "Content-Type": "application/json"
    },
  }

  try {
    const result = await encryptPayload(req,options,false,true,true)
    // const result = await encryptPayload(req, _options, false, false);    
    return result.data
  }
  catch (err) {
    // console.log(err)
  }
});

export const bankInfo = createAsyncThunk( 
  "staticData/bankInfo",
  async (payload) => {
  let params = {
    body: payload
  };
  const req = `${BASE_URL}/workflow/bankInfo`
  const encryptedAPIParams = await encryptPayload("",params,true,true)
  const options = {
    method: 'POST',
    body: JSON.stringify(encryptedAPIParams),
    headers: {
      "Content-Type": "application/json"
    },
  }
  const _options = {
    method: 'POST',
    headers: {
      "Content-Type": "application/json"
    },
  }

  try {
    const result = await encryptPayload(req,options,false,true,true)
    // const result = await encryptPayload(req, _options, false, false);    
    return result.data
  }
  catch (err) {
    // console.log(err)
  }
});

export const getDataBasedOnExpression = async (gstnbr, expression) => {
  const req = `${BASE_URL}/workflow/getDataBasedOnExpression`
  let inputData = {
    gstnbr: gstnbr,
    expression: expression
  };
  let params = {
    body: inputData,
  };
  const encryptedBodyRes = await encryptPayload("", params, true, true);
  const options = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(encryptedBodyRes),
  };
  try {
    let response = await encryptPayload(req, options, false, false);
    return response;

  } catch (err) {
    console.log(err);
    return "";
  }
}

export const getFormComponents = async (payload) => {
  const req = `${BASE_URL}/workflow/formComponents`;
  let params = {
    body: payload
  };
  const encryptedBodyRes = await encryptPayload("", params, true, true);
  const options = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(encryptedBodyRes),
  };
  try {
    let response = await encryptPayload(req, options, false, true, true);
    return response.data;
  } catch (err) {
    console.log(err);
    return "";
  }
}

export const ValidateCsvData = createAsyncThunk(
  "fetchApi/validateCsvData",
  async (params) => {
    const req = `${BASE_URL}/workflow/validateCsvData`;
    let req_body = {
      body: params,
    };
    const encryptedBodyRes = await encryptPayload("", req_body, true, true);
    const options = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(encryptedBodyRes),
    };
    try {
      const result = await encryptPayload(req, options, false, true,true);
      return result;
    } catch (err) {
      // // console.log(err);
    }
  }
);

export const createBulkPrimaryWorkFlows = createAsyncThunk("bulkInvite",async (data, cb) => {
  const req = `${BASE_URL}/workflow/createBulkPrimaryWorkFlows`;
  let params = {
    body: data
  }
  const encryptedBodyRes = await encryptPayload('', params, true, true);
  const options = {
    method: 'POST',
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(encryptedBodyRes)
  }
  const _options = {
    method: 'POST',
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data)
  }

  try {
    const result = await encryptPayload(req, options, false, true,true);
    return result;

    }
  
  catch (error) {
    throw error
  }
});

export const fetchTerritoryInfo = createAsyncThunk(
  "staticData/fetchTerritoryDetailbyUserId",
  async (params, { dispatch }) => {
    const req = `${BASE_URL}/users/fetchTerritoryDetailbyUserId`;
    let req_body = {
      body: params,
    };
    const encryptedBodyRes = await encryptPayload("", req_body, true, true);
    const options = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(encryptedBodyRes),
    };
    try {
      const result = await encryptPayload(req, options, false, true, true);
      let response = result?.data
      const { Territory, Region, Unit, Company } = response;
      if (Territory?.length === 1) {
        const [{ territory_name: TerritoryName,territory_code: TerritoryCode }] = Territory;
        const [{ region_name: RegionName,region_code: RegionCode }] = Region;
        const [{ unit_name: UnitName,unit_code: UnitCode }] = Unit;
        const [{ company_name: CompanyName }] = Company;
        const dependentFields = [
          { key: params?.name, value: TerritoryName} ,{key: params?.name +"_custom_field", value: TerritoryCode},
          { key: params?.dependentfield.find(field => field.includes('region')) ? 'region' : null, value: RegionName },{ key: params?.dependentfield.find(field => field.includes('region')) ? 'region_custom_field' : null, value: RegionCode },
          { key: params?.dependentfield.find(field => field.includes('sbu-unit')) ? 'sbu-unit' : null, value: UnitName },{ key: params?.dependentfield.find(field => field.includes('sbu-unit')) ? 'sbu-unit_custom_field' : null, value: UnitCode },
          { key: params?.dependentfield.find(field => field.includes('company')) ? 'company' : null, value: CompanyName }
        ].filter(field => field.key !== null);
        dependentFields.forEach(field => {
          dispatch(setSelectedData(field));
        });
      }
      return result.data;
    } catch (err) {
      console.log(err);
    }
  }
);
export const fetchRegionInfoByTerritoryName = createAsyncThunk(
  "staticData/fetchInfoTerritory",
  async (params, { dispatch }) => {
    const req = `${BASE_URL}/users/fetchTerritoryDetailbyUserId`;
    let req_body = {
      body: params,
    };
    const encryptedBodyRes = await encryptPayload("", req_body, true, true);
    const options = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(encryptedBodyRes),
    };
    try {
      const result = await encryptPayload(req, options, false, true, true);
      let response = result?.data
      const { Region, Unit } = response;
      if (Region?.length === 1 && Unit?.length === 1) {
        const [{ region_name: RegionName,region_code: RegionCode, }] = Region;
        const [{ unit_name: UnitName,unit_code: UnitCode, }] = Unit;
        const dependentFields = [
          { key: params?.dependentfield.find(field => field.includes('region')) ? 'region' : null, value: RegionName },{ key: params?.dependentfield.find(field => field.includes('region')) ? 'region_custom_field' : null, value: RegionCode },
          { key: params?.dependentfield.find(field => field.includes('sbu-unit')) ? 'sbu-unit' : null, value: UnitName },{ key: params?.dependentfield.find(field => field.includes('sbu-unit')) ? 'sbu-unit_custom_field' : null, value: UnitCode },
        ].filter(field => field.key !== null);
        dependentFields.forEach(field => {
          
          dispatch(setSelectedData(field));
        });
      }

      return result.data;
    } catch (err) {
      console.log(err);
    }
  }
);


export const getDuplicateData = async (payload) => {
  const req = `${BASE_URL}/workflow/getDuplicateData`;
  let params = {
    body: payload
  };
  const encryptedBodyRes = await encryptPayload("", params, true, true);
  const options = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(encryptedBodyRes),
  };
  try {
    let res = await encryptPayload(req, options, false, false, true);
    let response = await encryptPayload(req, options, false, true, true);
    return {
      previous_data: res?.data?.previous_data, 
      response
    };
  } catch (err) {
    console.log(err);
    return "";
  }
}

export const getAddressList = createAsyncThunk( 
  "staticData/getAddressList",
  async (payload) => {
  let params = {
    body: payload
  };
  const req = `${BASE_URL}/workflow/getAddressList`
  const encryptedAPIParams = await encryptPayload("",params,true,true)
  const options = {
    method: 'POST',
    body: JSON.stringify(encryptedAPIParams),
    headers: {
      "Content-Type": "application/json"
    },
  }
  const _options = {
    method: 'POST',
    headers: {
      "Content-Type": "application/json"
    },
  }
  try {
    const result = await encryptPayload(req,options,false,true,true)
    return result.data
  }
  catch (err) {
  }
});


export const fetchDistrictInfo = createAsyncThunk(
  "staticData/fetchDistrictInfo",
  async (params, { dispatch }) => {
    const req = `${BASE_URL}/workflow/fetchDistrictInfo`;
    let req_body = {
      body: params,
    };
    const encryptedBodyRes = await encryptPayload("", req_body, true, true);
    const options = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(encryptedBodyRes),
    };
    try {
      const result = await encryptPayload(req, options, false, false, true);
      return result?.districtList
    } catch (err) {
      console.log(err);
    }
  }
);

export const fetchSubRegisterOfficeInfo = createAsyncThunk(
  "staticData/fetchSubRegisterOfficeInfo",
  async (params, { dispatch }) => {
    const req = `${BASE_URL}/workflow/fetchDistrictInfo`;
    let req_body = {
      body: params,
    };
    const encryptedBodyRes = await encryptPayload("", req_body, true, true);
    const options = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(encryptedBodyRes),
    };
    try {
      const result = await encryptPayload(req, options, false, false, true);
      return result?.subregisterofficeList
    } catch (err) {
      console.log(err);
    }
  }
);

export const getAllOptionList = createAsyncThunk( 
  "staticData/getAllOptionList",
  async (payload) => {
  let params = {
    body: payload
  };
  const req = `${BASE_URL}/users/getAllOptionList`
  const encryptedAPIParams = await encryptPayload("",params,true,true)
  const options = {
    method: 'POST',
    body: JSON.stringify(encryptedAPIParams),
    headers: {
      "Content-Type": "application/json"
    },
  }
  const _options = {
    method: 'POST',
    headers: {
      "Content-Type": "application/json"
    },
  }
  try {
    const result = await encryptPayload(req,options,false,true,true)
    return result.data
  }
  catch (err) {
  }
});